import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { ResponsiveDesignService } from 'src/app/common/services/responsive-design/responsive-design.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';

@Component({
    selector: 'app-me-success',
    templateUrl: './me-success.component.html',
    styleUrls: ['./me-success.component.less'],
    standalone: false
})
export class MeSuccessComponent implements OnInit {

  UIUtilityService: any = UIUtilityService;

  externalSettings!: any;
  message! : string[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SuccessDialogConfig,
    public dialog: MatDialogRef<MeSuccessComponent>,
    private srvES: ExternalSettingsService,
    protected srvRpDesign: ResponsiveDesignService) { }

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((settings) => {
      this.externalSettings = settings;
    });

    if (typeof this.data.message === 'string') {
      this.message = [this.data.message];
    }
    else {
      this.message = this.data.message;
    }

    if (this.data.autoCloseMs && this.data.autoCloseMs > 0) {
      setTimeout(() => {
        if (this.dialog) {
          this.dialog.close();
        }
      }, this.data.autoCloseMs);
    }
  }

  success(event: any): void {
    this.dialog.close(true);
  }
}

export interface SuccessDialogConfig {
  title: string;
  message: string[] | string;
  buttonText: string | null;
  /** When set, the dialog closes automatically after this many milliseconds. */
  autoCloseMs?: number;
}